import React from 'react';
import './slider.sass';
import { Line } from '../../../line/line';


//projects
import blackLogoab84f380 from '../../../../media/img/projects/blackLogo.ab84f380.png';
import work2 from '../../../../media/img/projects/ArmConsulting.png';
//@ts-ignore
// import Slider from 'infinite-react-carousel';      -----46-56-----
//slider
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './slick.css'
import './slick-theme.css'
import { Quotes } from '../../../quotes/quotes';

export const MySlider = () => {
    const settings =  {
        autoplay: true,
        // centerMode: true,
        dots: true
      };
    return (
        <>
            <div className="SliderName">
                <div>
                    {/* Last projekts */}
                    <h2 id="Slider_h2">Последние проекты</h2>
                    <Line />
                </div>
            
                <div className="mainSlider">
                    <Slider { ...settings }>
                        <div>
                            <a target="_blank" href="https://vubo.herokuapp.com/#/"><img src={blackLogoab84f380} alt="1" /></a>
                        </div>

                        <div>
                            <a target="_blank" href="https://arm-consulting.kiev.ua/#/"><img src={work2} alt="1" /></a>
                        </div>
                        
                        <div>
                            <a target="_blank" href="https://vubo.herokuapp.com/#/"><img src={blackLogoab84f380} alt="1" /></a>
                        </div>
                    </Slider>
                </div> 
            </div>
            <div className="quotesSlider">
                <Quotes text="Программирование — это разбиение чего-то большого и невозможного на что-то маленькое и вполне реальное."
                author="«Jazzwant»" />
            </div>
        </>
    )
}